export default __webpack_public_path__ + "static/media/include_0_female@3x.8c184af4.jpg";